module.exports = __webpack_public_path__ + "img/marron-5.104c1ec6.png";